<style lang="scss" scoped>
.expire {
	cursor: pointer;
	&__fade {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.63);
		z-index: 3000;
	}
	&__body {
		position: fixed;
		top: 0;
		margin: auto;
		display: block;
		background: rgb(37, 37, 37);
		width: 100%;
		padding: 20px;
		z-index: 3001;
		color: rgba(255, 255, 255, 0.795);
		font-size: 20px;
		font-weight: bold;
		text-align: center;
	}
	&__emoji {
		height: 40px;
		margin-right: 10px;
	}
}
</style>


<template lang="pug">
.expire(@click="reload", v-if="show")
    .expire__fade
    .expire__body
        img(src="/static/img/icon-sets/emoji/7.png").expire__emoji
        | Session expired, click anywhere to login again.
</template>

<script>
import moment from "moment";

export default {
	props: {
		user: {
			required: true,
			type: Object
		}
	},

	data() {
		return {
			show: false
		};
	},

	methods: {
		reload() {
			location.reload();
		}
	},

	mounted() {
		const expire = moment.unix(this.user.session_expire);
		console.log("expire", expire.format("LLL"));

		setInterval(() => {
			if (moment().isSameOrAfter(expire)) {
				this.show = true;
			}
		}, 1000);
	}
};
</script>



// WEBPACK FOOTER //
// src/components/global/SessionExpireNotice.vue